import { connect } from 'react-redux';

import { compose } from 'ramda';
import { editUserAction } from 'src/actions';
import { selectCurrentPlan } from 'src/app/subscription/subscription-selectors';
import { withProviders } from 'src/common/hocs/with-providers';
import { selectUsername } from 'src/common/state/me/me-selectors';
import type { RootState, AppDispatch } from 'src/redux';

import SignIn from './sign-in-component';

const mapStateToProps = (state: RootState) => ({
  currentPlan: selectCurrentPlan(state),
  userName: selectUsername(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  reset: () => {
    dispatch(editUserAction({ error: null, message: null }));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProviders({ design: 'v1' })
)(SignIn);
